import { render, staticRenderFns } from "./DialogCancelContract.vue?vue&type=template&id=0b0bfe5a"
import script from "./DialogCancelContract.vue?vue&type=script&lang=js"
export * from "./DialogCancelContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports